// extracted by mini-css-extract-plugin
export default {"main":"LandingScreen_main__OlODw"};